/* Sweet Sleep — JS για τα ss-* sections (size finder + sticky add to cart).
   Δεν χρειάζεται build. Ανέβασέ το στο Assets. */
(function () {
  "use strict";

  /* ─────────────────────────────────────────────
     1. SIZE FINDER
     Διαβάζει τα variants από το <script data-ss-variants>,
     βρίσκει το πρώτο variant που χωράει τις διαστάσεις
     και το επιλέγει στη σελίδα προϊόντος.
  ───────────────────────────────────────────── */
  function parseSize(text) {
    // "90x200", "90 × 200 cm", "90/200" -> {w:90, l:200}
    var m = String(text).replace(/,/g, ".").match(/(\d{2,3})\s*[x×\/*]\s*(\d{2,3})/i);
    if (!m) return null;
    return { w: parseInt(m[1], 10), l: parseInt(m[2], 10) };
  }

  function initFinder(root) {
    var dataEl = root.querySelector("[data-ss-variants]");
    if (!dataEl) return;
    if (root.getAttribute("data-ss-finder-ready") === "true") return;
    root.setAttribute("data-ss-finder-ready", "true");
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent) || []; } catch (e) { return; }

    var sized = variants
      .map(function (v) {
        var cand = (v.opts || [v.option1, v.option2, v.option3]).concat([v.title]);
        var dims = null, label = v.title;
        for (var i = 0; i < cand.length && !dims; i++) { dims = parseSize(cand[i]); if (dims) label = cand[i]; }
        return dims ? { id: v.id, title: label, available: v.available, w: dims.w, l: dims.l } : null;
      })
      .filter(Boolean)
      .sort(function (a, b) { return a.w - b.w || a.l - b.l; });

    var wIn = root.querySelector("[data-ss-w]");
    var lIn = root.querySelector("[data-ss-l]");
    var hIn = root.querySelector("[data-ss-h]");
    var noteEl = root.querySelector("[data-ss-note]");
    var resEl = root.querySelector("[data-ss-res]");
    var btn = root.querySelector("[data-ss-apply]");
    var minH = parseInt(root.getAttribute("data-min-height") || "15", 10);
    var maxH = parseInt(root.getAttribute("data-max-height") || "40", 10);
    var txt = {
      enter: root.getAttribute("data-t-enter") || "",
      high: root.getAttribute("data-t-high") || "",
      none: root.getAttribute("data-t-none") || "",
      ok: root.getAttribute("data-t-ok") || "",
      special: root.getAttribute("data-t-special") || "",
      sold: root.getAttribute("data-t-sold") || "",
      heightStandard: root.getAttribute("data-t-height-standard") || "15–20 cm",
      heightMid: root.getAttribute("data-t-height-mid") || "21–30 cm",
      heightHigh: root.getAttribute("data-t-height-high") || "31–40 cm"
    };
    var match = null;
    var formWrap = root.querySelector("[data-ss-special-form]");
    var formBody = formWrap ? formWrap.querySelector("[data-ss-form-body]") : null;
    if (formBody) {
      formBody.addEventListener("input", function () { formBody.setAttribute("data-ss-touched", "1"); });
    }
    function toggleForm(show, w, l, h) {
      if (!formWrap) return;
      formWrap.hidden = !show;
      if (show && formBody && !formBody.getAttribute("data-ss-touched")) {
        formBody.value = "Meine Matratze: " + w + " x " + l + " cm, gewuenschte Hoehe " + h + " cm.";
      }
    }

function render() {
      var w = parseFloat(wIn && wIn.value) || 0;
      var l = parseFloat(lIn && lIn.value) || 0;
      var h = parseFloat(hIn && hIn.value) || 0;
      match = null;

      if (!w || !l || !h) { toggleForm(false); return set(txt.enter, "-"); }
      if ((minH && h < minH) || (maxH && h > maxH)) { toggleForm(true, w, l, h); return set(txt.high, txt.special); }

      var found = null;
      for (var i = 0; i < sized.length; i++) {
        if (sized[i].w === w && sized[i].l === l) { found = sized[i]; break; }
      }
      if (!found) { toggleForm(true, w, l, h); return set(txt.none, txt.special); }

      toggleForm(false);
      match = found;
      var heightBand = h <= 20 ? txt.heightStandard : (h <= 30 ? txt.heightMid : txt.heightHigh);
      match.heightBand = heightBand;
      set(found.available ? txt.ok : txt.sold, found.title + " · Rundumgummi " + heightBand);
    }

    function set(note, res) {
      if (noteEl) noteEl.textContent = note;
      if (resEl) resEl.textContent = res;
      if (btn) btn.disabled = !(match && match.available);
    }

    [wIn, lIn, hIn].forEach(function (el) {
      if (el) { el.addEventListener("input", render); el.addEventListener("change", render); }
    });

    if (btn) {
      btn.addEventListener("click", function () {
        if (!match) return;
        selectVariant(match.id);
        var cfg = document.querySelector("[data-ss-cfg]");
        if (cfg) {
          var skirt = cfg.querySelector('[data-ss-application][value="skirt"]');
          if (skirt) {
            skirt.checked = true;
            skirt.dispatchEvent(new Event("change", { bubbles: true }));
          }
          var heightChoice = Array.prototype.filter.call(
            cfg.querySelectorAll('[data-ss-role="fit"] input:not([data-ss-corner-value])'),
            function (input) { return match.heightBand && input.value.indexOf(match.heightBand) > -1; }
          )[0];
          if (heightChoice) {
            heightChoice.checked = true;
            heightChoice.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
        var target = document.querySelector("[data-ss-scroll-target], .product__info-wrapper, product-information, main");
        if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90, behavior: "smooth" });
      });
    }

    render();
  }

  /* Επιλέγει variant με τον τρόπο που δουλεύει σε OS 2.0 themes (Horizon/Dawn):
     πατά το αντίστοιχο input στο variant picker· αν δεν υπάρχει, αλλάζει το URL. */
  function selectVariant(id) {
    /* Eigener Konfigurator vorhanden? Dann dort die Größe setzen. */
    var cfg = document.querySelector("[data-ss-cfg]");
    if (cfg) {
      var vs = [];
      try { vs = JSON.parse(cfg.querySelector("[data-ss-variants]").textContent) || []; } catch (e) {}
      var hit = vs.filter(function (x) { return String(x.id) === String(id); })[0];
      if (hit) {
        var sizeGroup = cfg.querySelector('[data-ss-role="size"]');
        var pos = sizeGroup ? parseInt(sizeGroup.getAttribute("data-ss-opt"), 10) : 1;
        var sizeVal = hit.opts ? hit.opts[pos - 1] : hit.o1;
        var r = sizeGroup ? Array.prototype.filter.call(sizeGroup.querySelectorAll("input"), function (i) { return i.value === sizeVal; })[0] : null;
        if (r) { r.checked = true; r.dispatchEvent(new Event("change", { bubbles: true })); return; }
      }
    }
    var radio = document.querySelector('input[type="radio"][value*="' + id + '"]');
    var picker = document.querySelector("variant-selects, variant-radios, variant-picker, product-form");

    if (picker) {
      var inputs = picker.querySelectorAll('input[type="radio"], option');
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        var vid = el.getAttribute("data-variant-id") || el.getAttribute("data-option-value-id") || el.value;
        if (String(vid) === String(id)) {
          if (el.tagName === "OPTION") {
            el.parentNode.value = el.value;
            el.parentNode.dispatchEvent(new Event("change", { bubbles: true }));
          } else {
            el.checked = true;
            el.dispatchEvent(new Event("change", { bubbles: true }));
          }
          return;
        }
      }
    }
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event("change", { bubbles: true })); return; }

    var url = new URL(window.location.href);
    url.searchParams.set("variant", id);
    window.location.href = url.toString();
  }

  /* ─────────────────────────────────────────────
     2. STICKY ADD TO CART
  ───────────────────────────────────────────── */
  function initSticky(root) {
    if (root.getAttribute("data-ss-sticky-ready") === "true") return;
    root.setAttribute("data-ss-sticky-ready", "true");
    var form = root.querySelector("[data-ss-sticky-form]");
    var idInput = root.querySelector("[data-ss-sticky-id]");
    var subEl = root.querySelector("[data-ss-sticky-sub]");
    var btn = root.querySelector("[data-ss-sticky-btn]");
    var priceEl = root.querySelector("[data-ss-sticky-price]");
    var variants = [];
    try { variants = JSON.parse(root.querySelector("[data-ss-variants]").textContent) || []; } catch (e) {}

    function money(cents) {
      var fmt = root.getAttribute("data-money-format") || "€{{amount}}";
      var loc = document.documentElement.lang || "de";
      var n = (cents / 100).toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return fmt.indexOf("{{amount}}") > -1 ? fmt.replace("{{amount}}", n) : n + " €";
    }

    function sync(id) {
      var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (subEl) subEl.textContent = v.title;
      if (priceEl) priceEl.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available
          ? (root.getAttribute("data-t-add") || "In den Warenkorb")
          : (root.getAttribute("data-t-sold") || "Ausverkauft");
        if (priceEl && v.available) { btn.textContent = btn.textContent + " · " + money(v.price); }
      }
    }

    function currentId() {
      var p = new URL(window.location.href).searchParams.get("variant");
      if (p) return p;
      var main = document.querySelector('form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]');
      return main ? main.value : (idInput ? idInput.value : null);
    }

    /* Παρακολούθηση αλλαγών variant: URL, events των themes, και το κύριο form */
    ["variant:change", "variantChange", "product-info:loaded", "on:variant:change"].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { sync(currentId()); }, 60); });
    });
    document.addEventListener("change", function (e) {
      if (e.target.closest && e.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, variant-picker')) {
        setTimeout(function () { sync(currentId()); }, 80);
      }
    });
    window.addEventListener("popstate", function () { sync(currentId()); });

    /* Εμφάνιση μόλις φύγει από το κάδρο το κύριο κουμπί αγοράς */
    var anchor = document.querySelector('[data-ss-sticky-anchor], .product-form__buttons, product-form button[type="submit"]');
    if (anchor && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        root.classList.toggle("is-visible", !entries[0].isIntersecting);
      }, { rootMargin: "-10px 0px 0px 0px" }).observe(anchor);
    } else {
      root.classList.add("is-visible");
    }

    if (form) {
      form.addEventListener("submit", function () {
        if (btn) btn.textContent = "…";
      });
    }

    sync(currentId());
  }

  /* ─────────────────────────────────────────────
     3. PRODUKT-KONFIGURATOR (3 Optionen + DHL)
  ───────────────────────────────────────────── */
  function initConfigurator(root) {
    if (root.getAttribute("data-ss-cfg-ready") === "true") return;
    root.setAttribute("data-ss-cfg-ready", "true");
    var variants = [];
    try { variants = JSON.parse(root.querySelector("[data-ss-variants]").textContent) || []; } catch (e) { return; }
    var ship = [];
    try { ship = JSON.parse(root.getAttribute("data-ship")) || []; } catch (e) {}

    var freeFrom = parseInt(root.getAttribute("data-free-from") || "0", 10);
    var txt = {
      free: root.getAttribute("data-t-free") || "kostenlos",
      incl: root.getAttribute("data-t-incl") || "inkl.",
      sold: root.getAttribute("data-t-sold") || "Ausverkauft",
      unavail: root.getAttribute("data-t-unavail") || "Nicht verfügbar",
      atc: root.getAttribute("data-t-atc") || "In den Warenkorb"
    };
    var loc = root.getAttribute("data-locale") || document.documentElement.lang || "de";
    var moneyFmt = root.getAttribute("data-money") || "{{amount}} €";

    var idInput = root.querySelector("[data-ss-id]");
    var priceEl = root.querySelector("[data-ss-price]");
    var compareEl = root.querySelector("[data-ss-compare]");
    var atc = root.querySelector("[data-ss-atc]");
    var atcLabel = root.querySelector("[data-ss-atc-label]");
    var atcTotal = root.querySelector("[data-ss-atc-total]");
    var qtyInput = root.querySelector("[data-ss-qty-input]");
    var sizeName = root.querySelector("[data-ss-size-name]");
    var applicationInputs = Array.prototype.slice.call(root.querySelectorAll("[data-ss-application]"));
    var heightWrap = root.querySelector("[data-ss-height-wrap]");
    var cornerInput = root.querySelector("[data-ss-corner-value]");
    var heightInputs = Array.prototype.slice.call(root.querySelectorAll('[data-ss-role="fit"] input:not([data-ss-corner-value])'));
    var lastHeightValue = (heightInputs.filter(function (input) { return input.checked; })[0] || {}).value || null;

    function money(cents) {
      var n = (cents / 100).toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      var m = moneyFmt.match(/\{\{\s*amount[^}]*\}\}/);
      return m ? moneyFmt.replace(m[0], n) : n + " €";
    }

    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-ss-opt]"));
    var positions = groups.map(function (g) { return parseInt(g.getAttribute("data-ss-opt"), 10); });
    var posSize = parseInt(root.getAttribute("data-pos-size") || "0", 10);

    function selectedAll() {
      var out = {};
      groups.forEach(function (g) {
        var el = g.querySelector("input:checked");
        out[g.getAttribute("data-ss-opt")] = el ? el.value : null;
      });
      return out;
    }
    function matches(v, sel, overridePos, overrideVal) {
      for (var i = 0; i < positions.length; i++) {
        var p = positions[i];
        var want = p === overridePos ? overrideVal : sel[p];
        if (want !== null && v.opts[p - 1] !== want) return false;
      }
      return true;
    }
    function findVariant(sel, overridePos, overrideVal) {
      return variants.filter(function (v) { return matches(v, sel, overridePos, overrideVal); })[0] || null;
    }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function syncApplication() {
      var application = applicationInputs.filter(function (input) { return input.checked; })[0];
      if (!application) return;
      if (application.value === "corners") {
        if (heightWrap) heightWrap.hidden = true;
        var chosenHeight = heightInputs.filter(function (input) { return input.checked; })[0];
        if (chosenHeight) lastHeightValue = chosenHeight.value;
        if (cornerInput) cornerInput.checked = true;
        heightInputs.forEach(function (input) { input.checked = false; });
        return;
      }
      if (heightWrap) heightWrap.hidden = false;
      if (cornerInput) cornerInput.checked = false;
      var selectedHeight = heightInputs.filter(function (input) { return input.checked; })[0];
      if (!selectedHeight) {
        var remembered = heightInputs.filter(function (input) { return !input.disabled && input.value === lastHeightValue; })[0];
        var firstAvailable = remembered || heightInputs.filter(function (input) { return !input.disabled; })[0];
        if (firstAvailable) firstAvailable.checked = true;
      }
    }

    /* Aufpreise relativ zur billigsten Wahl in derselben Größe / Befestigung */
    function updateDeltas(sel) {
      root.querySelectorAll("[data-ss-delta]").forEach(function (el) {
        var pos = parseInt(el.getAttribute("data-ss-delta"), 10);
        var val = el.getAttribute("data-value");
        var v = findVariant(sel, pos, val);
        var input = el.closest(".ss-opt").querySelector("input");
        if (!v) { el.textContent = txt.unavail; input.disabled = true; return; }
        input.disabled = false;
        var group = variants.filter(function (x) {
          for (var i = 0; i < positions.length; i++) {
            var p = positions[i];
            if (p !== pos && sel[p] !== null && x.opts[p - 1] !== sel[p]) return false;
          }
          return true;
        });
        var baseline = Math.min.apply(null, group.map(function (x) { return x.price; }));
        if (heightWrap && heightWrap.contains(el)) {
          var standardHeight = heightInputs[0];
          var standardVariant = standardHeight ? findVariant(sel, pos, standardHeight.value) : null;
          if (standardVariant) baseline = standardVariant.price;
        }
        var d = v.price - baseline;
        el.textContent = d > 0 ? "+ " + money(d) : txt.incl;
      });
    }

    function addWorkdays(n) {
      var d = new Date(), k = 0;
      while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) k++; }
      return d;
    }
    function fmtDate(d) {
      try { return d.toLocaleDateString(loc, { weekday: "short", day: "numeric", month: "short" }); }
      catch (e) { return d.toLocaleDateString(); }
    }
    function updateShipping(total) {
      ship.forEach(function (s, i) {
        var costEl = root.querySelector('[data-ss-ship-cost="' + i + '"]');
        var winEl = root.querySelector('[data-ss-ship-window="' + i + '"]');
        if (costEl) costEl.textContent = (s.free_eligible && freeFrom && total >= freeFrom) ? txt.free : money(s.cost);
        if (winEl) winEl.textContent = s.min === s.max ? fmtDate(addWorkdays(s.min)) : fmtDate(addWorkdays(s.min)) + " – " + fmtDate(addWorkdays(s.max));
      });
    }

    function sync(pushUrl) {
      var sel = selectedAll();
      var v = findVariant(sel);
      if (sizeName && posSize) sizeName.textContent = "— " + (sel[posSize] || "");
      updateDeltas(sel);

      if (!v) {
        if (atc) { atc.disabled = true; }
        if (atcLabel) atcLabel.textContent = txt.unavail;
        if (idInput) { idInput.value = ""; idInput.disabled = true; }
        return;
      }
      var total = v.price * qty();
      if (idInput) { idInput.value = v.id; idInput.disabled = false; }
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare > v.price) { compareEl.textContent = money(v.compare); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      if (atc) atc.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? txt.atc : txt.sold;
      if (atcTotal) atcTotal.textContent = money(total);
      updateShipping(total);

      if (pushUrl && window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        history.replaceState({}, "", url.toString());
      }
      /* Andere Sections (Sticky-Bar, Galerie des Themes) informieren */
      document.dispatchEvent(new CustomEvent("variant:change", { bubbles: true, detail: { variant: v } }));
    }

    /* Mobile: <select> für die Größe spiegelt die Radio-Buttons */
    var sizeSelect = root.querySelector("[data-ss-size-select]");
    var sizeGroup = root.querySelector('[data-ss-role="size"]');
    if (sizeSelect && sizeGroup) {
      sizeSelect.addEventListener("change", function () {
        var r = Array.prototype.filter.call(sizeGroup.querySelectorAll("input"), function (i) { return i.value === sizeSelect.value; })[0];
        if (r) { r.checked = true; sync(true); }
      });
    }
    root.addEventListener("change", function (e) {
      if (e.target.matches("[data-ss-application]")) {
        syncApplication();
        sync(true);
        return;
      }
      if (e.target.matches("[data-ss-opt] input, [data-ss-ship] input, [data-ss-qty-input]")) {
        if (sizeSelect && sizeGroup && e.target.closest('[data-ss-role="size"]')) sizeSelect.value = e.target.value;
        sync(true);
      }
    });
    root.querySelectorAll("[data-ss-qty]").forEach(function (b) {
      b.addEventListener("click", function () {
        var n = parseInt(b.getAttribute("data-ss-qty"), 10);
        qtyInput.value = Math.min(9, Math.max(1, qty() + n));
        sync(false);
      });
    });

    var form = root.querySelector("[data-ss-form]");
    if (form) {
      form.addEventListener("submit", function () { if (atcLabel) atcLabel.textContent = "…"; });
    }
    syncApplication();
    sync(false);
  }

  function normalizeLegacyHeightCopy() {
    document.querySelectorAll("[data-ss-finder]").forEach(function (finder) {
      finder.setAttribute("data-min-height", "15");
      finder.setAttribute("data-max-height", "40");
      if ((finder.getAttribute("data-t-high") || "").indexOf("30") > -1) {
        finder.setAttribute("data-t-high", "Außerhalb 15–40 cm");
      }
      var intro = finder.querySelector(".ss-finder__p");
      if (intro && intro.textContent.indexOf("nächste passende Größe") > -1) {
        intro.textContent = "Breite und Länge der Matratze, dann die Gesamthöhe inklusive Topper. Bei Zwischenmaßen oder Sondergrößen fertigen wir dein Maß auf Anfrage.";
      }
    });

    document.querySelectorAll(".ss-facts__v").forEach(function (value) {
      var label = value.parentElement && value.parentElement.querySelector(".ss-facts__l");
      if (value.textContent.trim() === "30 cm" && label && label.textContent.indexOf("Topper") > -1) {
        value.textContent = "40 cm";
        label.textContent = "Gesamthöhe inklusive Topper";
      }
    });

    document.querySelectorAll(".ss-faq__item").forEach(function (item) {
      var question = item.querySelector(".ss-faq__q");
      var answer = item.querySelector(".ss-faq__a");
      if (question && answer && question.textContent.indexOf("Matratze mit Topper") > -1 && answer.textContent.indexOf("bis 30 cm") > -1) {
        answer.innerHTML = "<p>Ja. Miss die Gesamthöhe von Matratze und Topper zusammen. Du kannst zwischen 15–20 cm, 21–30 cm und 31–40 cm wählen. Wir verwenden den passenden Baumwollsteg für die gewählte Höhe.</p>";
      }
    });
  }

  function boot() {
    normalizeLegacyHeightCopy();
    document.querySelectorAll("[data-ss-finder]").forEach(initFinder);
    document.querySelectorAll("[data-ss-sticky]").forEach(initSticky);
    document.querySelectorAll("[data-ss-cfg]").forEach(initConfigurator);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
